import { authTokenCookie } from '../utils/CookieMaker';
// import { Environment } from '../utils/Environment';

export const getNoCacheHeaders = () => {
  let { token, idToken } = authTokenCookie();
  return {
    "Cache-control": "no-cache, no-store, must-revalidate, post-check=0, pre-check=0",
    Pragma: "no-cache",
    Expires: "0",
   //"Authorization": `Bearer ${token}`,
   //"idToken": idToken
    //  applicationId: "1",
    //  userId: userId,
     "Ocp-Apim-Subscription-Key": ``,
     "svwpToken":`ent-abs-auth=${token};ent-abs-itkn=${idToken}`
  };
};
